var map = {
	"./01.png": "d75a",
	"./02.png": "c6ea",
	"./03.png": "30ed",
	"./04.png": "825e",
	"./05.png": "74f3",
	"./06.png": "be41",
	"./07.png": "f7ab",
	"./08.png": "bbea",
	"./big/01.png": "7a23",
	"./big/02.png": "4eaf",
	"./big/03.png": "284f",
	"./big/04.png": "5edd",
	"./big/05.png": "590c",
	"./big/06.png": "bf22",
	"./big/07.png": "447b",
	"./big/08.png": "bfab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";